"use client";

import { usePassportProvider } from "@/context";
import { useGetWalletLatestEarnings } from "@/hooks/api";
import { useQuests } from "@/hooks/cms";
import { QuestsSection } from "@components/TilesSection/QuestsSection";
import { QuestTileType } from "@imx-tokens-ts/gems-game/domain";

export const OnboardingQuests = () => {
  const { data, isLoading } = useQuests();
  const onboardingQuests = data?.onboardingQuests || [];
  const { walletAddress } = usePassportProvider();
  const { latestEarnings } = useGetWalletLatestEarnings(walletAddress);

  return (
    <QuestsSection
      testId="onboarding-quests"
      tileType={QuestTileType.OnboardingQuest}
      title="Earn Gems. Discover New Games."
      filterOptions={[]}
      latestEarnings={latestEarnings}
      data={onboardingQuests}
      isLoading={isLoading}
      isAboveTheFold
      showDivider={false}
    />
  );
};
